// Sidebar.tsx
import React, { useState } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import logo from '../assets/imgs/aci6-header.webp';
import Accordion from './Accordion';
import { IMenu } from '../configs/header';
import { X } from 'lucide-react';

type ISidebar = {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  menu: IMenu[];
}

const Sidebar = ({isSidebarOpen, toggleSidebar, menu}: ISidebar) => {
  const [selected, setSelected] = useState<number | null>(null);

  const toggle = (index: number) => {
    setSelected(selected === index ? null : index);
  };

  return (
    <>
      {/* Sidebar */}
      <div
        id="sidebar"
        className={cn(
          'lg:hidden fixed top-0 right-0 bottom-0 z-[100] w-screen h-screen bg-white border-r border-gray-200 pt-4 pb-10 overflow-y-auto transition-transform duration-300 transform',
          {
            'translate-x-0': isSidebarOpen,
            '-translate-x-full': !isSidebarOpen
          }
        )}
        role="dialog"
        aria-label="Menu di navigazione"
        aria-modal="true"
      >
        <div className="px-2 flex justify-between items-center">
          <div className='flex items-center gap-4'>
            <img src={logo} width={80} height={80} alt='ASA 2 logo' loading="lazy" decoding="async" />
            <h1 className='font-cream text-2xl'>Menu</h1>
          </div>
          <button
            type="button"
            className="mr-5 p-2"
            onClick={toggleSidebar}
            aria-label="Chiudi menu"
          >
            <X color="black" aria-hidden="true" />
          </button>
        </div>
        <nav className="p-6 w-full flex flex-col flex-wrap" aria-label="Menu principale">
          <ul className="space-y-1.5">
            {menu.map((item, index) => {
              if (!item.items.length || item.hideItemsOnHeader) {
                return (
                  <li key={`${item.text.replace(' ', '-')}-${index}`}>
                    <Link
                      className="flex items-center gap-x-3.5 py-4 px-4 bg-gray-100 text-lg text-black rounded-lg"
                      to={item.link}
                      onClick={toggleSidebar}
                    >
                      {item.icon && <item.icon aria-hidden="true" />}
                      {item.text}
                    </Link>
                  </li>
                );
              }
              return (
                <li key={`${item.text.replace(' ', '-')}-${index}`}>
                  <Accordion
                    item={item}
                    index={index}
                    selected={selected}
                    toggle={toggle}
                    toggleSidebar={toggleSidebar}
                  />
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
